import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, DESC_ORDER } from "@duosoftbg/nacid-components";

export interface IValProfQualificationSearch {
  applicant: string;
  recordNumber: string;
  applicationDateFrom: string;
  applicationDateTo: string;
  applicationCountryName: string;
  recognizedProfessionName: string;
  certificateNumber: string;
  status: string;
  page: number;
  pageSize: number;
  order: string;
  orderBy: string;
}

export const ivalProfQualificationsSearch: IValProfQualificationSearch = {
  applicant: null,
  recordNumber: null,
  applicationDateFrom: null,
  applicationDateTo: null,
  applicationCountryName: null,
  recognizedProfessionName: null,
  certificateNumber: null,
  status: null,
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "applicationDate",
};

export interface IValARNacidSearch {
  applicant: string;
  recordNumber: string;
  status: string;
  foreignUniversity: string;
  recognizedSpeciality: string;
  applicationDateFrom: string;
  applicationDateTo: string;
  decisionNumber: string;
  country: string;
  eduLevel: string;
  page: number;
  pageSize: number;
  order: string;
  orderBy: string;
}
export const ivalARNacidSearch: IValARNacidSearch = {
  applicant: null,
  recordNumber: null,
  status: null,
  foreignUniversity: null,
  recognizedSpeciality: null,
  applicationDateFrom: null,
  applicationDateTo: null,
  decisionNumber: null,
  country: null,
  eduLevel: null,
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "applicationDate",
};

export interface IValARUniversitySearch {
  applicant: string;
  status: string;
  foreignUniversity: string;
  recognizedSpeciality: string;

  page: number;
  pageSize: number;
  order: string;
  orderBy: string;
}
export const ivalARUniversitySearch: IValARUniversitySearch = {
  applicant: null,
  status: null,
  foreignUniversity: null,
  recognizedSpeciality: null,

  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "createdDate",
};
